import "./drawing/surface.js";
import "./drawing/html.js";

    export const __meta__ = {
        id: "drawing",
        name: "Drawing API",
        category: "framework",
        description: "The Kendo UI low-level drawing API",
        depends: [ "core", "color", "popup", "icons" ]
    };